/**
 * @Pipe
 * @description pipe to format numeric values to argentina readable currency values
 * @input number
 * @output formatted numeric value
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'amountFormat',
})
export class AmountFormatPipe implements PipeTransform {
    transform(value: any, isDecimal: boolean = true): any {
        if (value === '' || value == undefined) return '';
        let parts = (+value).toFixed(2).split(".");
        let num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (+parts[1] ? "." + parts[1] : isDecimal ? ".00" : "");
        return num;
    }

}
